import { DocumentCellRendererComponent } from "src/app/components/crm/companies/pages/company-info-tabs/document-cell-renderer/document-cell-renderer.component";
import { AgColDefsI, AgGridI,} from "../../../../shared/components/ag-grid/ag-grid.model";
import { ActionsComponent } from "./actions/actions.component";

export class DuplicatesTab {
}


const TypeColumn: AgColDefsI = {
    headerName: "Type",
    field: "type",
    minWidth: 140,
    width: 140,
    suppressMovable: true,
    editable : false,
    cellStyle:{'padding-left':"22px",'color':'#646E76'},
    flex:1,
    cellRenderer: params => params.value ?params.value : "&#8212",  
};

const CompanyNameColumn: AgColDefsI = {
    headerName: "Company Name",
    field: "companyName",
    minWidth: 400,
    width:400,
    sortable: true,
    editable : false,
    suppressMovable: true,
    cellStyle:{ 'color':'var(--sitewide_primary_accent_color)','padding-left':"22px"},
    //cellClass: "padding-left-38px",
    
};
const MPNColumn: AgColDefsI = {
  headerName: "MPN",
  field: "mpn",
  minWidth: 400,
  width:400,
  sortable: true,
  editable : false,
  suppressMovable: true,
  cellStyle:{'padding-left':"22px",'color':'#646E76'},
  cellRenderer: params => params.value ?params.value : "&#8212",
};
const MFRColumn: AgColDefsI = {
  headerName: "MFR",
  field: "mfr",
  minWidth: 400,
  width:400,
  sortable: true,
  editable : false,
  suppressMovable: true,
  cellStyle:{'padding-left':"22px",'color':'#646E76'},
  cellRenderer: params => params.value ?params.value : "&#8212",
};
const DescriptionColumn: AgColDefsI = {
  headerName: "Description",
  field: "description",
  minWidth: 400,
  width:400,
  sortable: true,
  editable : false,
  suppressMovable: true,
  cellStyle:{'padding-left':"22px",'color':'#646E76'},
  cellRenderer: params => params.value ?params.value : "&#8212",
};

const PhoneColumn: AgColDefsI = {
headerName: "Phone Number",
field: "phoneNumber",
minWidth: 145,
width:145,
sortable: true,
editable : false,
suppressMovable: true,
flex:1,
cellStyle:{'padding-left':"22px",'color':'#646E76'},
};
  
const AddressColumn: AgColDefsI = {
headerName: "Address",
field: "address",
minWidth: 550,
width:550,
sortable: true,
editable : false,
suppressMovable: true,
cellStyle:{'padding-left':"22px",'color':'#646E76'},
};
  
const ActionColumn: AgColDefsI = {
headerName: "Action",
field: "action",
sortable: true,
cellClass: "padding-left-38px",
minWidth: 150,
editable : false,
flex:1,
cellRenderer:ActionsComponent,
cellStyle:{'padding-left':"22px",'color':'#646E76'},
};

const SICCodeColumn: AgColDefsI = {
  headerName: "SIC Code",
  field: "sic",
  minWidth: 150,
  maxWidth:550,
  flex:1,
  sortable: true,
  suppressMovable: true,
  cellStyle:{'padding-left':"22px",'color':'#646E76'},
  };
  const NAICSCodeColumn: AgColDefsI = {
    headerName: "NAICS Code",
    field: "naics",
    minWidth: 150,
    maxWidth:550,
    flex:1,
    sortable: true,
    editable : false,
    suppressMovable: true,
    cellStyle:{'padding-left':"22px",'color':'#646E76'},
    };
    const IndustryColumn: AgColDefsI = {
      headerName: "Industry",
      field: "industry",
      minWidth: 150,
      maxWidth:550,
      flex:1,
      sortable: true,
      editable : false,
      suppressMovable: true,
      cellStyle:{'padding-left':"22px",'color':'#646E76'},
      };
      const PartNumberColumn: AgColDefsI = {
        headerName: "Part Number",
        field: "companyName",
        minWidth: 200,
        suppressMovable: true,
        editable : false,
        flex:1,
        cellStyle:{'padding-left':"22px", 'color':'var(--sitewide_primary_accent_color)'
        },
      };
      const PlaceholderColumn: AgColDefsI = {
        headerName: "Placeholder",
        field: "Placeholder",
        minWidth: 200,
        suppressMovable: true,
        editable : false,
        flex:1,
        cellStyle:{'padding-left':"22px",'color':'#646E76'},
      };
      const CustomerColumn: AgColDefsI = {
        headerName: "Customer",
        field: "companyName",
        minWidth: 200,
        suppressMovable: true,
        editable : false,
        flex:1,
        cellStyle:{'padding-left':"22px",'color':'#646E76'},
        
      };
      const ContactColumn: AgColDefsI = {
        headerName: "Contact",
        field: "companyName",
        minWidth: 200,
        editable : false,
        suppressMovable: true,
        flex:1,
        cellStyle:{'padding-left':"22px",'color':'#646E76'},
        
      };
                             
export const ColDefsCodeDuplicates: AgColDefsI[] = [
  TypeColumn,
  SICCodeColumn,
  NAICSCodeColumn,
  IndustryColumn,
  ActionColumn,
];

export const ColDefsCommonDuplicates: AgColDefsI[] = [
  TypeColumn,
  MPNColumn,
  MFRColumn,
  DescriptionColumn,
  ActionColumn,
];

export const ColDefsConsignmentDuplicates: AgColDefsI[] = [
  TypeColumn,
  PartNumberColumn,
  PlaceholderColumn,
  PlaceholderColumn,
  ActionColumn,
];
export const ColDefsOEMExcessDuplicates: AgColDefsI[] = [
  TypeColumn,
  PartNumberColumn,
  CustomerColumn,
  ContactColumn,
  ActionColumn,
];

  export const ColDefsDuplicates: AgColDefsI[] = [
    TypeColumn,
    CompanyNameColumn,
    PhoneColumn,
    AddressColumn,
    ActionColumn,
  ];

export const ColDefsRequirementBOMDuplicates: AgColDefsI[] = [
  TypeColumn,
  MPNColumn,
  MFRColumn,
  DescriptionColumn,
  ActionColumn,
];

  export const AgGridImportCompaniesDuplicatesTab: AgGridI = {
    colDefs: ColDefsDuplicates,
    rowSelection: "multiple",
  };
  export const AgGridImportCodecrosswalkDuplicatesTab: AgGridI = {
    colDefs: ColDefsCodeDuplicates,
    rowSelection: "multiple",
  };
  export const AgGridImportCommonDuplicatesTab: AgGridI = {
    colDefs: ColDefsCommonDuplicates,
    rowSelection: "multiple",
  };
  export const AgGridImportConsignmentDuplicate: AgGridI = {
    colDefs: ColDefsConsignmentDuplicates,
    rowSelection: "multiple",
  };
  export const AgGridImportOEMExcessDuplicate: AgGridI = {
    colDefs: ColDefsOEMExcessDuplicates,
    rowSelection: "multiple",
  };
  export const AgGridImportBOMDuplicatesTab: AgGridI = {
    colDefs: ColDefsRequirementBOMDuplicates,
    rowSelection: "multiple",
  };
